module.exports = __webpack_public_path__ + "img/sankaku_53_red.c6a470e0.png";